import React, { CSSProperties, MouseEventHandler } from 'react';
import { CcIcon } from '@utp/components-react';
import { useHistory } from 'react-router-dom';

import { Wrapper } from './styled';

interface IProps {
  disabled?: boolean;
  iconAppend?: string;
  iconPrepend?: string;
  sizeIcon?: number;
  outlined?: boolean;
  style?: CSSProperties;
  text?: string;
  children?: React.ReactNode;
  to?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const ReusableButton = ({
  disabled,
  iconAppend,
  iconPrepend,
  sizeIcon,
  onClick,
  outlined,
  style,
  children,
  text,
  to,
  type
}: IProps) => {
  const history = useHistory();

  const handlerOnClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (onClick) {
      onClick(e);
      (e.target as any).blur();
      (e.target as any).parentElement.blur();
    }
    if (to) history.push(to);
  };

  return (
    <Wrapper
      style={{ ...style }}
      outlined={outlined}
      data-testid="reutilizable-button"
      onClick={handlerOnClick}
      type={type}
      disabled={disabled ?? false}
      className={disabled ? 'disabled' : ''}
    >
      {iconPrepend && <CcIcon size={sizeIcon ?? 16} name={iconPrepend} />}
      {children ? <>{children}</> : <span>{text}</span>}
      {iconAppend && <CcIcon size={sizeIcon ?? 16} name={iconAppend} />}
    </Wrapper>
  );
};

export default ReusableButton;
